import * as React from 'react'
import cx from 'classnames'
import Icon from 'components/Icon'
import styles from './RadioGroup.sass'
import { useBrandingSettings } from 'hooks/branding'

interface RadioGroupProps {
  children?: React.ReactNode
}

export function RadioGroup({ children }: RadioGroupProps) {
  return <div className={styles.radioGroup}>{children}</div>
}

interface RadioItemProps {
  children?: React.ReactNode
  selected: boolean
  'data-test'?: string
  onChange: (newValue: boolean) => unknown
}

export function RadioItem({
  children,
  selected,
  'data-test': dataTest,
  onChange,
}: RadioItemProps) {
  const branding = useBrandingSettings()
  const change = React.useCallback(() => {
    onChange(!selected)
  }, [selected, onChange])

  return (
    <a
      tabIndex={0}
      aria-checked={selected}
      className={cx(styles.radioItem, selected && styles.selected)}
      data-test={dataTest}
      onClick={change}
    >
      <div className={cx(styles.selectedRadioIcon, selected && styles.pop)}>
        <Icon
          auto
          color={branding.themePrimary}
          name={selected ? 'radio-selected' : 'radio'}
        />
      </div>
      <div className={styles.radioItemContent}>{children}</div>
    </a>
  )
}
